const DEFAULT_APP_URL = "https://webhookstorage.com";
const DEFAULT_INGEST_URL = "https://in.webhookstorage.com";

function normalizeUrl(value: string | undefined, fallback: string): string {
  const trimmed = value?.trim();
  if (!trimmed) return fallback;

  try {
    const url = new URL(trimmed);
    return url.toString().replace(/\/$/, "");
  } catch {
    return fallback;
  }
}

export function getAppUrl(): string {
  return normalizeUrl(import.meta.env.VITE_PUBLIC_APP_URL, DEFAULT_APP_URL);
}

export function getManagementApiBaseUrl(): string {
  return `${getAppUrl()}/v1`;
}

export function getIngestBaseUrl(): string {
  return normalizeUrl(import.meta.env.VITE_PUBLIC_INGEST_URL, DEFAULT_INGEST_URL);
}

export function getEndpointIngestUrl(endpointId: string): string {
  return `${getIngestBaseUrl()}/${endpointId}`;
}
